/**
 * 港前报价管理前端接口
 */

import { request } from '@/utils/http'
import { type BatchDeleteRequest, type PageResponse } from '@/api/types/common'
import {
  type InitiateConsultationRequest, type InqQuotPriceChargingItemVO,
  type ShokzQuotationBaseModel, type ShokzQuotationBatchSubmitRequest, type ShokzQuotationChargingItemVO,
  type ShokzQuotationPageRequest,
  type ShokzQuotationSaveRequest
} from './quotation-base'

/**
 * 港前报价模型（继承基础报价模型）
 */
export interface ShokzQuotationPrePortModel extends ShokzQuotationBaseModel {
}

/**
 * 港前报价分页查询请求参数
 */
export interface ShokzQuotationPrePortPageRequest extends ShokzQuotationPageRequest {
}

/**
 * 港前报价保存请求参数
 */
export interface ShokzQuotationPrePortSaveRequest extends ShokzQuotationSaveRequest {
}

/**
 * 分页查询港前报价列表
 */
export const pageQuotationPrePort = (params: ShokzQuotationPrePortPageRequest) => {
  return request.post<PageResponse<ShokzQuotationPrePortModel>>('/price/shokzQuotation/pre-port/page', params)
}

/**
 * 根据ID获取港前报价详情
 */
export const getQuotationPrePortById = (id: string) => {
  // 提取纯数字ID部分，去除可能的额外信息
  const pureId = id.split(/\s+/)[0];
  return request.post<ShokzQuotationPrePortModel>('/price/shokzQuotation/pre-port/get', { id: pureId })
}

/**
 * 根据询价编号获取港前报价详情
 */
export const getQuotationPrePortByInquiryNo = (inquiryNo: string) => {
  return request.post<ShokzQuotationPrePortModel>('/price/shokzQuotation/pre-port/get', { inquiryNo })
}

/**
 * 新增港前报价
 */
export const saveQuotationPrePort = (params: ShokzQuotationPrePortSaveRequest) => {
  return request.post<boolean>('/price/shokzQuotation/pre-port/save', params)
}

export const queryQuotationPrePortByInquiry = (params: { inquiryId?: string | number; inquiryNo?: string }) => {
  return request.post<ShokzQuotationPrePortModel[]>('/price/shokzQuotation/pre-port/queryByInquiry', params)
}

export const createQuotationPrePortScheme = (quotationId: string | number) => {
  return request.post<string | number>(`/price/shokzQuotation/pre-port/createScheme/${quotationId}`)
}

/**
 * 修改港前报价
 */
export const updateQuotationPrePort = (params: ShokzQuotationPrePortSaveRequest) => {
  return request.post<boolean>('/price/shokzQuotation/pre-port/update', params)
}

/**
 * 批量提交港前报价方案
 */
export const batchSubmitQuotationPrePort = (params: ShokzQuotationBatchSubmitRequest<ShokzQuotationPrePortSaveRequest>) => {
  return request.post<boolean>('/price/shokzQuotation/pre-port/batchSubmit', params)
}

export const validateQuotationTokenPrePort = (token: string, quotationId: string, tenantId: string) => {
  return request.post<boolean>('/price/shokzQuotation/pre-port/validateToken', { token, quotationId, tenantId })
}

/**
 * 批量删除港前报价
 */
export const batchDeleteQuotationPrePort = (params: BatchDeleteRequest) => {
  return request.post<boolean>('/price/shokzQuotation/pre-port/batch-delete', params)
}

/**
 * 发起新磋商
 * 针对指定的整箱报价单发起新的磋商记录,更新报价单磋商状态为"磋商中"
 */
export const initiateConsultationPrePort = (params: InitiateConsultationRequest) => {
  return request.post<boolean>('/price/shokzQuotation/pre-port/initiateConsultation', params)
}

/**
 * 商户报价单加价保存
 */
export const businessQuotationMarkupPrePort = (params: InqQuotPriceChargingItemVO) => {
  return request.post<InqQuotPriceChargingItemVO>('/price/shokzQuotation/pre-port/businessQuotationMarkup', params)
}

/**
 * 供应商报价单加价保存
 */
export const supplierQuotationMarkupPrePort = (params: ShokzQuotationChargingItemVO) => {
  return request.post<ShokzQuotationChargingItemVO>('/price/shokzQuotation/pre-port/supplierQuotationMarkup', params)
}
